import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import styled, { css } from 'styled-components';

import { theme } from '_constants/theme';

const { devices, fontSizes, spaces } = theme;

// eslint-disable-next-line prettier/prettier, react/display-name
const StyledDescriptionButton = styled(forwardRef(({ borderColor, textColor, mobileColor, mobileColumnMode, large, ...props }, ref) => <div ref={ref} {...props} />))`
  display: flex;
  flex-direction: row;
  box-sizing: border-box;
  align-items: center;
  padding: ${spaces.small - 2}px;
  width: 100%;

  background: ${({ color }) => color};
  border: 1px solid ${({ borderColor }) => borderColor};
  border-radius: 16px;

  font-family: 'Aeonik';
  font-style: normal;
  font-size: ${fontSizes.regular}px;
  font-weight: 400;
  color: ${({ textColor }) => textColor};

  .childrenDescription {
    flex-grow: 1;
  }

  .prefixDescription,
  .suffixDescription {
    display: inline-flex;
    align-items: center;
  }

  .suffixDescription {
    padding-left: ${spaces.small - 2}px;
  }

  ${({ large }) =>
    large &&
    css`
      padding-top: ${spaces.medium}px;
      padding-bottom: ${spaces.medium}px;
      padding-left: ${spaces.medium}px;
      padding-right: ${spaces.medium}px;
      font-size: ${fontSizes.large}px;
    `}

  @media ${devices.tablet} {
    padding-left: ${spaces.regular}px;
    padding-right: ${spaces.regular}px;
    background: ${({ mobileColor }) => mobileColor};

    ${({ large }) =>
      large &&
      css`
        padding-top: ${spaces.regular}px;
        padding-bottom: ${spaces.regular}px;
        padding-left: ${spaces.regular}px;
        padding-right: ${spaces.regular}px;
        .prefixDescription,
        .suffixDescription {
          padding: 0px;
          width: 100%;
        }
        button {
          width: 100%;
          justify-content: center;
        }
      `}

    .childrenDescription {
      margin-left: 0px;
    }

    ${({ mobileColumnMode }) =>
      mobileColumnMode &&
      css`
        width: 100%;
        flex-direction: column;
        .suffixDescription {
          padding-top: ${spaces.regular}px;
        }
      `}
  }
`;

const DescriptionButton = ({
  children,
  color,
  borderColor,
  textColor,
  prefix,
  suffix,
  mobileColor,
  mobileColumnMode,
  large,
}) => {
  return (
    <StyledDescriptionButton
      color={color}
      mobileColor={mobileColor}
      mobileColumnMode={mobileColumnMode}
      borderColor={borderColor}
      textColor={textColor}
      large={large}
    >
      {prefix && <span className="prefixDescription">{prefix}</span>}
      <span className="childrenDescription">{children}</span>
      {suffix && <span className="suffixDescription">{suffix}</span>}
    </StyledDescriptionButton>
  );
};

DescriptionButton.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node),
  ]),
  borderColor: PropTypes.string,
  color: PropTypes.string,
  textColor: PropTypes.string,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  mobileColumnMode: PropTypes.bool,
  large: PropTypes.bool,
};

export default DescriptionButton;
